"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=void 0;var _ethers=require("ethers"),_formatBN=require("./lib/formatBN"),_default=()=>/**
   * Format an numerical amount with its decimals
   *
   * @param {*} amount The absolute amount, without any decimals.
   * @param decimals The number of decimal places to format to. Defaults to 18.
   * @return {Promise<radspec/evaluator/TypedValue>}
   */async(amount,decimals=18)=>{const amountBn=_ethers.BigNumber.from(amount),formattedAmount=(0,_formatBN.formatBN)(amountBn,(0,_formatBN.tenPow)(decimals),+decimals,!1);return{type:"string",value:formattedAmount}};exports.default=_default;
//# sourceMappingURL=withDecimals.js.map